import React, { useEffect } from "react";
import "./HomeSection.css";
import AOS from "aos";
import "aos/dist/aos.css";
import HomeImg from "../../images/home_villa.jpg";
import client1 from "../../images/client1.jpg";
import client2 from "../../images/client2.jpg";
import client3 from "../../images/client3.jpg";
import client4 from "../../images/client4.jpg";
import client5 from "../../images/client5.jpg";
import { FaWhatsapp } from "react-icons/fa";

export default function HomeSection() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
    AOS.refresh();
  }, []);

  return (
    <section id="home">
      {/* Full-bleed hero wrapper */}
      <div className="hero-wrapper">

        {/* Background image */}
        <img src={HomeImg} alt="Property" className="hero-bg-image" />

        {/* Dark gradient overlay */}
        <div className="hero-overlay" />

        {/* Left content */}
        <div className="hero-content" data-aos="fade-right">
          <div className="homeTitle">
            <span>O seu </span>
            <span className="highlight-circle">
              parceiro
              {/* <svg
                className="hand-drawn-circle"
                viewBox="0 0 120 120"
                preserveAspectRatio="none"
              >
                <defs>
                  <filter id="pencilTexture">
                    <feTurbulence
                      type="fractalNoise"
                      baseFrequency="0.8"
                      numOctaves="2"
                      result="noise"
                    />
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="1" />
                  </filter>
                </defs>
                <path
                  d="M60,35
                     C85,30 110,35 110,60
                     C110,85 85,110 60,110
                     C35,110 10,85 10,60
                     C10,30 75,60 25,53"
                  stroke="#ffb302a5"
                  strokeWidth="3"
                  fill="transparent"
                  strokeDasharray="4,2,1,3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  filter="url(#pencilTexture)"
                />
              </svg> */}
            </span>
            <span> para <br />Alojamento Local</span>
          </div>

          <p className="hero-description">
            <span>A nossa equipa experiente trata de todos os aspetos do processo de arrendamento </span>
            <span>online. Deixa a Guestza gerir o teu imóvel e proporcionar uma experiência única </span>
            <span>aos hóspedes, aumentando assim os teus rendimentos.</span>
          </p>

          <button className="hero-cta-button" onClick={() => {
            const el = document.getElementById("contacts");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}>
            <span>AGENDAR REUNIÃO</span>
            <span className="hero-cta-arrow">↗</span>
          </button>
        </div>

        {/* Clients — bottom right */}
        <div className="hero-clients" data-aos="fade-up">
          <div className="hero-client-avatars">
            {[client1, client2, client3, client4, client5].map((client, index) => (
              <img
                key={index}
                src={client}
                alt={`Client ${index + 1}`}
                className="hero-client-avatar"
              />
            ))}
          </div>
          <span className="hero-clients-label">+56 Clientes felizes</span>
        </div>

        {/* WhatsApp floating button */}
        <a
          href="https://wa.me/"
          target="_blank"
          rel="noopener noreferrer"
          className="hero-whatsapp-btn"
          aria-label="WhatsApp"
        >
          <FaWhatsapp size={28} />
        </a>

      </div>
    </section>
  );
}